<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- EDITAR-->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-body">
          <div class="row">
            <!-- INSTRUÇÕES -->
            <div class="col-sm-12">
              <div class="form-group">
                <span style="color: red">Instruções: Imagem 400x250 e Fundo branco ou transparente</span>
              </div>
            </div>

            <!-- ARQUIVO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="exampleInputFile">Arquivo</label>
                <input class="form-control" type="file" @change="onChange" />
              </div>
            </div>

            <!-- LEILÃO -->
            <div class="col-sm-6">
              <div class="form-group" id="form_group_comitente">
                <label for="comitente">Leilão ID</label>

                <div class="input-group mb-3">
                  <input class="form-control" id="nome" v-model="leilao_str" />
                  <span class="input-group-append">
                    <button
                      type="button"
                      class="btn btn-primary"
                      id="confirmar"
                      @click="buscarLeiloes"
                      data-toggle="modal"
                      data-target="#leilao-modal"
                    >
                      Buscar
                    </button>
                  </span>
                </div>
              </div>
            </div>

            <!-- LOTES -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_cidade">Lotes</label>

                <select class="custom-select rounded-0" v-model="formData.lote_id" @change="setUrlLote">
                  <option value=""></option>
                  <option v-for="lote in lotes" :key="lote.id" :value="lote.id">
                    {{ lote.lote_numero + " - " + lote.lote_titulo }}
                  </option>
                </select>
              </div>
            </div>

            <!-- URL -->
            <div class="col-sm-6" v-if="formData.leilao_id == ''">
              <div class="form-group">
                <label for="nome">Url</label>
                <input class="form-control" id="nome" placeholder="Url" v-model="formData.url" />

                <span v-if="formData.leilao_id == '' || !formData.leilao_id" style="color: red" v-for="error in v$.url.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- EXPIRA EM -->
            <div class="col-sm-6" v-if="formData.leilao_id == ''">
              <div class="form-group">
                <label for="nome">Expira em</label>

                <InputMask
                  id="basic"
                  class="form-control"
                  v-model="formData.expire_at"
                  placeholder="__/__/____  00:00"
                  mask="99/99/9999 99:99"
                  slotChar="__/__/____ 00:00"
                />

                <span
                  v-if="formData.leilao_id == '' || !formData.leilao_id"
                  style="color: red"
                  v-for="error in v$.expire_at.$errors"
                  :key="error.$uid"
                >
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="sendFileS3()">Salvar</button>
          <a type="submit" href="/admin/banners" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="leilao-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Leilões</h4>
            <br />

            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th style="width: 10px">Id</th>
                    <th>Leilão</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(leilao, index) in leiloes" :key="leilao.id">
                    <td data-label="Seq">{{ leilao.id }}</td>
                    <td data-label="Seq">{{ leilao.leilao_titulo }}</td>

                    <td data-label="Ações">
                      <button style="margin-left: 15px" class="btn btn-primary btn-sm" @click="selecionarLeilao(leilao)" data-dismiss="modal">
                        Selecionar
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <button id="leilao-modal" style="margin-left: 15px" data-toggle="modal" data-target="#leilao-modal" class="btn btn-danger btn-sm">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";
import moment from "moment";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";
import InputMask from "primevue/inputmask";

export default {
  mixins: [sweetAlert, Swal],

  props: ["banner"],

  components: { Loading, InputMask },

  data() {
    return {
      nome: "",
      isLoading: false,
      upload_files: "",
      lotes: [],
      leiloes: "",
      leilao_str: "",
    };
  },

  setup() {
    const formData = reactive({
      url: "",
      expire_at: "",
      leilao_id: "",
      lote_id: "",
    });

    const rules = computed(() => {
      let local_rules = {};

      if (formData.leilao_id == "" || !formData.leilao_id) {
        local_rules.expire_at = { required };
      }

      if (formData.leilao_id == "" || !formData.leilao_id) {
        local_rules.url = { required };
      }

      return local_rules;
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    if (this.banner.url) {
      this.formData.url = this.banner.url;
    }

    if (this.banner.expires_at) {
      this.formData.expire_at = this.formatSelectedDate2(this.banner.expires_at);
    }

    if (this.banner.leilao_id) {
      this.formData.leilao_id = this.banner.leilao_id;
    }

    console.log(this.banner);

    if (this.banner.leilao_id) {
      this.leilao_str = this.banner.leilao_id;
      this.searchLotes();
    }

    this.buscarLeiloes();
  },

  methods: {
    selecionarLeilao(leilao) {
      this.formData.leilao_id = leilao.id;
      this.leilao_selecionado = leilao;

      this.leilao_str = leilao.leilao_titulo;

      this.searchLotes();
    },

    buscarLeiloes() {
      let data = {
        inicio: 0,
        tamanho: 20,
        id: this.leilao_str,
        id_like: true,
      };

      console.log(data);

      axios
        .post(`/admin/leilao/search`, data)
        .then((response) => {
          this.leiloes = response.data.leiloes;
          this.my_leiloes = response.data.leiloes;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },
    onChange(e) {
      this.upload_files = e.target.files[0];
    },

    async sendFileS3() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        if (this.upload_files) {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("id", "1");
            formData.append("path", "rochaleiloes2/banners/");
            formData.append("file", this.upload_files);

            axios
              .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload`, formData)
              .then((response) => {
                console.log("ENVIANDO PARA O BANCO\n");

                this.update(response.data.key);
              })
              .catch((error) => {
                console.log(error);

                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error.response.data.error);
                console.log(error);
                reject();
              });
          });
        } else {
          this.update(null);
        }
      }
    },

    async update(file) {
      this.isLoading = true;

      if (file) {
        let fileName = file.split("/");

        console.log("Atualizando agora ");
        console.log(fileName[fileName.length - 1]);

        fd.append("file", fileName[fileName.length - 1]);
        fd.append("path", "rochaleiloes2/banners");
      }

      let fd = new FormData();
      fd.append("id", this.banner.id);
      fd.append("url", this.formData.url);
      fd.append("expires_at", this.formatSelectedDate3(this.formData.expire_at));

      if (this.formData.leilao_id) {
        fd.append("leilao_id", this.formData.leilao_id);
      }

      if (this.formData.lote_id) {
        fd.append("lote_id", this.formData.lote_id);
      }

      console.log("Cadastrando");
      console.log(this.formData.expire_at);
      console.log(this.formatSelectedDate3(this.formData.expire_at));

      axios
        .post(`/admin/banner/update`, fd)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessageWithButton("Sucesso", "Dados editados");

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    searchLotes() {
      if (this.formData.leilao_id) {
        let data = {
          leilao_id: this.formData.leilao_id,
        };

        this.formData.lote_id = null;
        this.formData.expire_at = null;

        axios
          .post(`/admin/lote/find_by_leilao`, data)
          .then((response) => {
            this.lotes = response.data.lotes;
            this.formData.url = null;

            console.log("Lotes buscados");
            console.log(this.lotes);

            if (this.banner.lote_id) {
              this.formData.lote_id = this.banner.lote_id;
            }

            this.setUrlLeilao();
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      } else {
        this.formData.url = null;
      }
    },

    setUrlLeilao() {
      if (this.formData.leilao_id && this.leiloes) {
        let indice = this.findLeilao(this.formData.leilao_id);

        if (indice >= 0) {
          this.formData.url = "/leilao/" + this.leiloes[indice].id + "/lotes";
        }
      }
    },

    setUrlLote() {
      let indice = this.findLote(this.formData.lote_id);

      if (indice >= 0) {
        this.formData.url = "/lote/" + this.lotes[indice].id;
      }
    },

    findLeilao(id) {
      let indice = this.leiloes.findIndex((element) => element["id"] == id);

      return indice;
    },

    findLote(id) {
      let indice = this.lotes.findIndex((element) => element["id"] == id);

      return indice;
    },

    //FORMATA A DATA VINDA DO BANCO (De yyyy-MM-DD HH:mm:ss Para DD-MM-yyyy HH:mm:ss)
    formatSelectedDate2(date) {
      return moment(date).format("DD-MM-yyyy HH:mm:ss");
    },

    //FORMATA A DATA PARA ENVIAR PARA O BANCO (De DD-MM-yyyy HH:mm:ss Para yyyy-MM-DD HH:mm:ss )
    formatSelectedDate3(date) {
      if (date) {
        return moment(date, "DD/MM/yyyy HH:mm").format("yyyy-MM-DD HH:mm:ss");
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.current-page {
  background-color: #428bca !important;
  color: white;
}

.modal-content {
  width: 1500px;
  margin-left: -430px;
}

@media screen and (max-width: 1600px) {
  .modal-content {
    width: 1350px;
    margin-left: -400px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1350px) {
  .modal-content {
    width: 1250px;
    margin-left: -350px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1100px;
    margin-left: -280px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 1000px;
    margin-left: -240px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
    min-width: 400px;
  }
}
</style>
